const PHONE_NUMBER_REGEXP = new RegExp(
  /^\s*(?:\+?(\d{1,3}))?([-. (]*(\d{3})[-. )]*)?((\d{3})[-. ]*(\d{2,4})(?:[-.x ]*(\d+))?)\s*$/
);

const EMAIL_REGEXP = new RegExp(/^[A-Za-z0-9@.+ ]+$/);
export { PHONE_NUMBER_REGEXP, EMAIL_REGEXP };
